// Client-side mirror of /app/backend/services/construction_hsn.py.
// Keeps the Monumental Studio HSN autofill instant (no round-trip)
// while the backend endpoint remains the source of truth for tests.
//
// Regenerate manually if the Python catalog changes — the guard test
// `test_construction_hsn_catalog.py::test_frontend_mirror_matches`
// asserts parity so drift is caught in CI.

export const CONSTRUCTION_HSN_CATALOG = [
  { label: "OPC Cement (Portland — Ordinary)", hsn: "25232910", gst: 18,
    keywords: ["cement", "opc", "ordinary portland", "portland cement", "cement 43", "cement 53", "ppc", "grey cement", "ultra tech", "ultratech", "ambuja", "acc", "shree cement"] },
  { label: "White Cement", hsn: "25232100", gst: 18,
    keywords: ["white cement", "birla white", "jk white"] },
  { label: "Portland Cement — Other Variants", hsn: "25232990", gst: 18,
    keywords: ["portland other", "psc", "slag cement", "sulphate resistant"] },
  { label: "Cement Clinker", hsn: "25231000", gst: 18,
    keywords: ["clinker"] },

  { label: "TMT / HSD Bars (Fe-500 / Fe-550)", hsn: "72142090", gst: 18,
    keywords: ["tmt", "hsd", "rebar", "fe 500", "fe500", "fe 550", "fe550", "reinforcement bar", "reinforcement"] },
  { label: "Structural Steel — Angles, Channels, Sections", hsn: "72163100", gst: 18,
    keywords: ["angle", "channel", "structural steel", "isa", "ismc", "isbb", "beam"] },
  { label: "MS Round Bars", hsn: "72149910", gst: 18,
    keywords: ["ms round", "round bar", "mild steel round"] },
  { label: "MS Plates / Sheets (Hot-rolled)", hsn: "72085110", gst: 18,
    keywords: ["ms plate", "ms sheet", "hot rolled plate", "hr plate", "hr sheet"] },
  { label: "GI Sheets (Galvanised)", hsn: "72104900", gst: 18,
    keywords: ["gi sheet", "galvanised sheet", "galvanized sheet"] },
  { label: "Binding Wire (Steel)", hsn: "72172010", gst: 18,
    keywords: ["binding wire", "steel wire", "gi wire"] },
  { label: "Steel Nails", hsn: "73170099", gst: 18,
    keywords: ["nail", "iron nail"] },
  { label: "Bolts, Nuts, Screws", hsn: "73181500", gst: 18,
    keywords: ["bolt", "nut", "screw", "fastener"] },

  { label: "M-Sand (Manufactured Sand)", hsn: "25171010", gst: 5,
    keywords: ["m-sand", "m sand", "msand", "manufactured sand", "crushed sand"] },
  { label: "River Sand · Natural Sand", hsn: "25051019", gst: 5,
    keywords: ["river sand", "natural sand", "sand"] },
  { label: "Coarse Aggregate (Crushed Stone)", hsn: "25171010", gst: 5,
    keywords: ["aggregate", "crushed stone", "20mm", "40mm", "12mm", "6mm", "jelly", "grit"] },
  { label: "Fly Ash", hsn: "26210090", gst: 5,
    keywords: ["fly ash", "flyash", "pozzolana"] },
  { label: "GSB / WMM Base Mix", hsn: "25171010", gst: 5,
    keywords: ["gsb", "wmm", "base mix", "sub-base"] },

  { label: "Clay Bricks (Fired)", hsn: "69041000", gst: 12,
    keywords: ["clay brick", "red brick", "brick"] },
  { label: "AAC Blocks (Autoclaved)", hsn: "68109990", gst: 18,
    keywords: ["aac block", "autoclaved", "aerocon", "siporex"] },
  { label: "Concrete Solid Blocks", hsn: "68101190", gst: 18,
    keywords: ["concrete block", "solid block", "cc block"] },
  { label: "Fly-Ash Bricks", hsn: "68159910", gst: 5,
    keywords: ["fly ash brick", "flyash brick"] },
  { label: "Ceramic Wall Tiles", hsn: "69072100", gst: 18,
    keywords: ["ceramic tile", "wall tile"] },
  { label: "Vitrified / Porcelain Tiles", hsn: "69072200", gst: 18,
    keywords: ["vitrified", "porcelain tile", "gvt", "pgvt"] },
  { label: "Roofing Tiles / Sheets", hsn: "69051000", gst: 18,
    keywords: ["roofing tile", "mangalore tile", "roof sheet"] },

  { label: "Marble Slabs / Tiles", hsn: "25151220", gst: 12,
    keywords: ["marble"] },
  { label: "Granite Slabs / Tiles", hsn: "25161200", gst: 12,
    keywords: ["granite"] },
  { label: "Kota / Kadappa Stone", hsn: "25152000", gst: 5,
    keywords: ["kota stone", "kadappa", "cuddapah"] },

  { label: "Ready-Mix Concrete (RMC)", hsn: "38245000", gst: 18,
    keywords: ["rmc", "ready mix", "readymix concrete", "concrete m20", "m25", "m30"] },
  { label: "Bitumen · Asphalt", hsn: "27149010", gst: 18,
    keywords: ["bitumen", "asphalt", "tar"] },
  { label: "Waterproofing Chemicals", hsn: "38249900", gst: 18,
    keywords: ["waterproof", "waterproofing", "dr fixit", "roffe", "sika"] },
  { label: "Concrete Admixture / Plasticiser", hsn: "38244000", gst: 18,
    keywords: ["admixture", "plasticiser", "plasticizer", "super plasticiser"] },
  { label: "Construction Adhesives · Sealants", hsn: "35069900", gst: 18,
    keywords: ["adhesive", "sealant", "epoxy", "silicone sealant"] },

  { label: "Emulsion Paint (Water-based)", hsn: "32091090", gst: 18,
    keywords: ["emulsion", "asian paint", "berger", "water paint"] },
  { label: "Enamel Paint (Oil-based)", hsn: "32089090", gst: 18,
    keywords: ["enamel", "oil paint", "gloss paint"] },
  { label: "Cement Primer", hsn: "32100010", gst: 18,
    keywords: ["primer", "wall primer"] },
  { label: "Distemper", hsn: "32100020", gst: 18,
    keywords: ["distemper"] },

  { label: "PVC Pipes", hsn: "39172390", gst: 18,
    keywords: ["pvc pipe", "upvc", "plumbing pipe"] },
  { label: "CPVC Pipes", hsn: "39172300", gst: 18,
    keywords: ["cpvc"] },
  { label: "HDPE Pipes", hsn: "39172190", gst: 18,
    keywords: ["hdpe"] },
  { label: "MS Pipes (Round, Welded)", hsn: "73063090", gst: 18,
    keywords: ["ms pipe", "mild steel pipe"] },
  { label: "GI Pipes (Galvanised)", hsn: "73063040", gst: 18,
    keywords: ["gi pipe", "galvanised pipe"] },
  { label: "Sanitary Fittings", hsn: "69101000", gst: 18,
    keywords: ["sanitary ware", "washbasin", "wc", "ewc", "toilet"] },

  { label: "Copper Wire (Insulated, ≤ 1000V)", hsn: "85444200", gst: 18,
    keywords: ["copper wire", "electric wire", "house wire", "wire cable"] },
  { label: "PVC Insulated Cable", hsn: "85444999", gst: 18,
    keywords: ["pvc cable", "armoured cable", "cable"] },
  { label: "Switches & Sockets", hsn: "85365020", gst: 18,
    keywords: ["switch", "socket", "modular switch"] },
  { label: "MCB / Circuit Breakers", hsn: "85362020", gst: 18,
    keywords: ["mcb", "circuit breaker", "rccb", "isolator"] },

  { label: "Plywood", hsn: "44123100", gst: 18,
    keywords: ["plywood", "ply"] },
  { label: "MDF Board", hsn: "44111400", gst: 18,
    keywords: ["mdf"] },
  { label: "Gypsum Board / False Ceiling", hsn: "68091100", gst: 12,
    keywords: ["gypsum", "false ceiling", "gyp board"] },
  { label: "POP · Plaster of Paris", hsn: "25202090", gst: 5,
    keywords: ["pop", "plaster of paris"] },

  { label: "Steel Doors / Frames", hsn: "73083000", gst: 18,
    keywords: ["steel door", "steel frame"] },
  { label: "Aluminium Windows / Doors", hsn: "76109010", gst: 18,
    keywords: ["aluminium window", "aluminum door", "aluminium door"] },
  { label: "Float Glass · Toughened Glass", hsn: "70051090", gst: 18,
    keywords: ["glass", "float glass", "toughened glass"] },

  { label: "Coal — Steam / Thermal", hsn: "27011990", gst: 5,
    keywords: ["coal", "steam coal", "thermal coal"] },
  { label: "Petroleum Coke (Pet Coke)", hsn: "27131100", gst: 18,
    keywords: ["pet coke", "petcoke", "petroleum coke"] },
];

const slugify = (s) =>
  (s || "").toString().toLowerCase()
    .replace(/[^a-z0-9\s]/g, " ")
    .replace(/\s+/g, " ")
    .trim();

export function suggestHsn(query, limit = 6) {
  const q = slugify(query);
  if (!q) return [];
  const tokens = q.split(" ").filter((t) => t);
  if (!tokens.length) return [];
  const phrase = tokens.join(" ");
  const hits = [];
  CONSTRUCTION_HSN_CATALOG.forEach((entry, idx) => {
    let score = 0;
    for (const kw of entry.keywords) {
      const kwl = kw.toLowerCase();
      if (kwl === phrase) score += 300;
      else if (phrase.includes(kwl) || kwl.includes(phrase)) score += 60;
      for (const tok of tokens) {
        if (tok.length < 2) continue;
        if (tok === kwl) score += 100;
        else if (kwl.startsWith(tok) || tok.startsWith(kwl)) score += 40;
        else if (tok.length >= 3 && (kwl.includes(tok) || tok.includes(kwl))) score += 15;
      }
    }
    if (score > 0) hits.push({ score, idx, entry });
  });
  hits.sort((a, b) => b.score - a.score || a.idx - b.idx);
  return hits.slice(0, limit).map((h) => h.entry);
}

export function lookupHsn(query) {
  return suggestHsn(query, 1)[0] || null;
}
